import React, { useContext, useState } from "react";
import { GlobalContext } from "../contexts/GlobalContext";
import Card from "../components/Card";

const Vacancy = () => {
  const { state } = useContext(GlobalContext);
  const { data } = state;

  // Bisa di hapus
  console.log("this is Vacancy");
  console.log(data);

  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    city: "",
    companyName: "",
    salaryMin: "",
  });

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleFilterChange = (event) => {
    setFilters({ ...filters, [event.target.name]: event.target.value });
  };

  const filteredData = data
    .filter((item) =>
      item.title.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter(
      (item) =>
        (filters.city ? item.company_city === filters.city : true) &&
        (filters.companyName
          ? item.company_name
              .toLowerCase()
              .includes(filters.companyName.toLowerCase())
          : true) &&
        (filters.salaryMin
          ? item.salary_min >= parseInt(filters.salaryMin)
          : true)
    );

  return (
    <div className="container mx-auto mt-24 mb-20 px-4">
      <div className="mb-6">
        <label className="block text-lg font-medium mb-2 ">
          Search by Job Title
        </label>

        <input
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          className="border rounded px-4 py-2 w-full mb-4 md:w-1/3"
        />
        <div className=" flex-wrap gap-4 mb-6">
          <label className="block text-lg font-medium mb-2">
            Filter by city
          </label>

          <input
            type="text"
            name="city"
            value={filters.city}
            onChange={handleFilterChange}
            className="border rounded px-4 py-2 w-full md:w-1/3"
          />
          <label className="block text-lg font-medium mb-2">
            Filter by company name
          </label>
          <input
            type="text"
            name="companyName"
            value={filters.companyName}
            onChange={handleFilterChange}
            className="border rounded px-4 py-2 w-full md:w-1/3"
          />
          <label className="block text-lg font-medium mb-2">
            Filter by minimum salary
          </label>
          <input
            type="number"
            name="salaryMin"
            value={filters.salaryMin}
            onChange={handleFilterChange}
            className="border rounded px-4 py-2 w-full md:w-1/3"
          />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredData.length === 0 ? (
            <p>No vacancies available</p>
          ) : (
            filteredData.map((vacancyData) => (
              <Card
                key={vacancyData.id}
                id={vacancyData.id}
                title={vacancyData.title}
                job_description={vacancyData.job_description}
                job_qualification={vacancyData.job_qualification}
                job_type={vacancyData.job_type}
                job_tenure={vacancyData.job_tenure}
                job_status={vacancyData.job_status}
                company_name={vacancyData.company_name}
                company_image_url={vacancyData.company_image_url}
                company_city={vacancyData.company_city}
                salary_min={vacancyData.salary_min}
                salary_max={vacancyData.salary_max}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Vacancy;
